import { render, staticRenderFns } from "./PromocodeModal.vue?vue&type=template&id=2968fc17&"
import script from "./PromocodeModal.vue?vue&type=script&lang=js&"
export * from "./PromocodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports